// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__8DD7M","contactItem":"Contacts_contactItem__2JIh9","contactTitle":"Contacts_contactTitle__h9SNR","contactText":"Contacts_contactText__7EmC2"};